<template>
  <div style="max-width: 90vw; margin: auto" fluid class="pa-0 fill-height align-start">
    <!-- Header / Toolbar -->
    <v-toolbar dark flat color="transparent" class="px-2 pt-2 mb-2">
      <v-btn outlined small rounded color="grey lighten-1" class="d-md-none mr-2 px-3" @click="$refs.treeManager.toggleDrawer()">
        <v-icon left small>mdi-file-tree</v-icon>
        Ordner
      </v-btn>

      <v-spacer></v-spacer>

      <!-- Actions -->
      <v-tooltip bottom v-if="userService.hasRight('d_fetchAllDocs')">
        <template v-slot:activator="{ on, attrs }">
          <v-btn icon class="mr-2" v-bind="attrs" v-on="on" @click="loadEmails">
            <v-icon>mdi-email-sync</v-icon>
          </v-btn>
        </template>
        <span>Neue Mails abrufen</span>
      </v-tooltip>

      <v-btn color="primary" depressed rounded @click="uploadMedia" class="ml-2">
        <v-icon left>mdi-cloud-upload</v-icon>
        <span class="d-none d-sm-inline">Hochladen</span>
      </v-btn>
    </v-toolbar>

    <!-- Hidden Fetchers/Dialogs -->
    <document-email-fetcher @newAttachements="reloadTreeManager" ref="documentMailFetcher" />

    <file-drop-upload
      :allowed="userService.hasRight('d_fetchAllDocs')"
      @hideDialog="showUploadDialog = false"
      :showUploadDialog="showUploadDialog"
      @fileUpload="reloadTreeManager" />

    <!-- Main Content Area -->
    <v-row no-gutters class="fill-height">
      <v-col cols="12" class="fill-height">
        <folder-tree-manager ref="treeManager" />
      </v-col>
    </v-row>
  </div>
</template>

<script>
import userService from "@/services/userService"
import documentEmailFetcher from "./components/documentEmailFetcher.vue"
import fileDropUpload from "./components/fileDropUpload.vue"
import folderTreeManager from "./folderTreeManager.vue"
import api from "@/api" // Stelle sicher, dass hier deine API-Funktion fetchDocumentEmails verfügbar ist.

export default {
  name: "Dashboard",
  components: { documentEmailFetcher, folderTreeManager, fileDropUpload },
  data() {
    return {
      userService,
      showUploadDialog: false,
    }
  },
  methods: {
    async uploadMedia() {
      this.showUploadDialog = true
    },
    async reloadTreeManager() {
      this.showUploadDialog = false
      this.$refs.treeManager.init()
    },
    async loadEmails() {
      // Rufe die Methode der Kind-Komponente auf, die den Request startet
      await this.$refs.documentMailFetcher.fetchMails()
    },
  },
}
</script>

<style scoped>
/* Eigene Styles können hier hinzugefuegt werden */
</style>
